import('./map_coords.scss')

export default function MapCoords(opts={}){
    BaseConstructor.call(this)
    let {map, options} = opts
    let elements = {}
    let context = this

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    function updateCoords(e) {    
      elements.lat.innerHTML = e.latlng.lat.toFixed(5);
      elements.lng.innerHTML = e.latlng.lng.toFixed(5);
    }
    
    init()
    
    function init(){
    	var elem = L.control({position: options?.position || 'bottomleft'});
		
        elem.onAdd = function (map) {
            elements.container = L.DomUtil.create('div', options.classList + " " +'map-coods-container');
            elements.container.innerHTML = '<div><i class="fas fa-crosshairs"></i></div><div><div>lat</div><div id="lat">-</div></div><div><div>lon</div><div id="lng">-</div></div>'
            L.DomEvent.disableClickPropagation(elements.container);

            elements.lat = elements.container.querySelector("#lat");
            elements.lng = elements.container.querySelector("#lng");
            
            return elements.container;
        };
        
        elem.addTo(map);

        map.on('mousemove', e=>{
            updateCoords(e)
        })
    }
}

MapCoords.prototype = Object.create(BaseConstructor.prototype)